
const data = [
  {
    title: '生态战略概述',
    description: '生态战略规划是帮助企业设计赢得竞争的蓝本，成功的关键在于深入行业理解和全视角市场研判基础上竞争模式与竞争手段的设计，导航企业跨越式发展的最优路径。'
  },
  {
    title: '服务内容',
    description: '产业链、行业竞争格局分析\n' +
      '企业战略执行能力分析评估\n' +
      '战略愿景、使命设计\n' +
      '标杆研究与对标分析\n' +
      '职能战略设计'
  },
  {
    title: '服务特点',
    description: '云恋科技强调生态战略规划格局、视野与战略执行“落地”的结合，不仅仅形成战略规划的文本，更强调战略规划与具体业务计划有机融合。'
  }
];

export default data;


// WEBPACK FOOTER //
// ./src/routes/Service/config/ecology-strategy.js